var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUndoneStepPersonalInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4816_77742)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.8891 33.7779V32.3557C32.8891 31.1982 32.8891 30.6194 32.7556 30.1461C32.4198 28.9555 31.4893 28.0249 30.2987 27.6892C29.8253 27.5557 29.2466 27.5557 28.0891 27.5557H19.9113C18.7538 27.5557 18.1751 27.5557 17.7018 27.6892C16.5111 28.0249 15.5806 28.9555 15.2448 30.1461C15.1113 30.6194 15.1113 31.1982 15.1113 32.3557V33.7779",
    stroke: "#707070",
    strokeWidth: 1.77778,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8891 18.2219C28.8891 20.922 26.7003 23.1108 24.0002 23.1108C21.3002 23.1108 19.1113 20.922 19.1113 18.2219C19.1113 15.5218 21.3002 13.333 24.0002 13.333C26.7003 13.333 28.8891 15.5218 28.8891 18.2219Z",
    stroke: "#707070",
    strokeWidth: 1.77778,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4816_77742"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndoneStepPersonalInfo);
export default __webpack_public_path__ + "static/media/undone-step-personal-info.5c014e577b7a31766daa290d5760370e.svg";
export { ForwardRef as ReactComponent };